export enum SearchRecipientsType {
    inContacts = 1,
    inChats,
    inContactsWithVariables,
}